
import {defineComponent, PropType} from "vue";
import {CodeDescriptionRestDto} from "@/api/pharma-cms-content-block/models";
import {BorderSideRestDtoModel} from "@/models/api/pharma-cms-content-page/BorderSideRestDtoModel";
import InputSelect from "@/components/UI/InputSelect.vue";
import InputNumber from "@/components/UI/InputNumber.vue";
import ColorSolidEditor from "@/components/layouts/content-pages/wysiwyg/misc/ColorSolidEditor.vue";
import GenericComponentWrapper from "@/components/base/GenericComponentWrapper.vue";
import {ComponentMixin} from "@/components/base/ComponentMixin";
import {EnumRestService} from "@/services/rest/enum/EnumRestService";
import {EnumClassNameCmsEnum} from "@/models/enum/EnumClassNameCmsEnum";
import {BorderSideRestDto} from "@/api/pharma-cms-content-page/models";

export default defineComponent({
  name: "BorderSideDetail",
  mixins: [ComponentMixin],
  components: {GenericComponentWrapper, InputSelect, InputNumber, ColorSolidEditor},
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Object as PropType<BorderSideRestDto | null>,
      default: null,
    },
    // Only shown in compact mode, where it names the side ("Boven", "Onder", …).
    label: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
    // Renders the narrow variant used for the four side panels: a heading instead of field labels,
    // and the colour dropdown across the full width. The wide variant puts style, width and colour
    // next to each other with their own labels.
    compact: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Greys the fields out without hiding them. Used for the shared section while the individual
    // sides are being edited, so it stays visible as a reference but cannot be changed.
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    errors: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.initialize();
  },
  data() {
    return {
      localDto: BorderSideRestDtoModel.createWithDefaults() as BorderSideRestDto,
      enumStyleCode: [] as CodeDescriptionRestDto[],
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(newValue: BorderSideRestDto | null) {
        this.localDto = newValue ? BorderSideRestDtoModel.cloneFrom(newValue) : BorderSideRestDtoModel.createWithDefaults();
      },
    }
  },
  methods: {
    async doInitialize(): Promise<void> {
      this.enumStyleCode =
        await EnumRestService.getInstance().getCmsEnumValuesByClassname(EnumClassNameCmsEnum.BORDER_STYLE);
    },
    emitModelChanged(): void {
      this.$emit('update:modelValue', this.localDto);
    }
  }
});
